import {
    IBook,
    IComment,
    ILesson,
    ILessonLight, ILessonsCategory, ILessonsResponse,
} from '@/interfaces';
import { CoursesState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';


export const mutations = {
    setLessonsCategories(state: CoursesState, payload: ILessonsCategory[]) {
        state.lessonsCategories = payload;
    },
    setLessons(state: CoursesState, payload: ILessonLight[]) {
        state.lessons = payload;
    },
    setLesson(state: CoursesState, payload: ILesson | null) {
        state.lesson = payload;
    },
    setComments(state: CoursesState, payload: IComment[]) {
        state.comments = payload;
    },
    setBooks(state: CoursesState, payload: IBook[]) {
        state.books = payload;
    },
    setBook(state: CoursesState, payload: IBook | null) {
        state.book = payload;
    },
};

const {commit} = getStoreAccessors<CoursesState | any, State>('');

export const commitSetLessonsCategories = commit(mutations.setLessonsCategories);
export const commitSetLessons = commit(mutations.setLessons);
export const commitSetLesson = commit(mutations.setLesson);
export const commitSetComments = commit(mutations.setComments);
export const commitSetBooks = commit(mutations.setBooks);
export const commitSetBook = commit(mutations.setBook);
